import React, {
  useEffect, useMemo, useState,
} from 'react'
import { string, func, object } from 'prop-types'
import Radio from '@active/react-ui/Radio'
import LinkButton from '@active/react-ui/LinkButton'
import IconButton from '@active/react-ui/IconButton'
import AddressStatic from '@active/react-address-editor/components/AddressStatic'
import { Locale } from '@active/react-utils/i18n'
import classNames from 'classnames'
import ShippingAddressEditor from './ShippingAddressEditor'
import { isDefaultAddress, ADD_NEW_SHIPPING_ADDRESS_ID } from './utils'
import './ShippingListItem.scss'

function ShippingListItem({
  id,
  selectId,
  shippingAddress = {},
  onDelete,
  onSetDefault,
}) {
  const [isEditMode, setIsEditmode] = useState(false)
  const isAddNew = useMemo(() => id === ADD_NEW_SHIPPING_ADDRESS_ID, [id])
  const isChecked = useMemo(() => selectId === id, [selectId, id])
  const isShowEditor = useMemo(() => isChecked && (isAddNew || isEditMode), [isAddNew, isChecked, isEditMode])
  const isShowSetAsDefault = useMemo(() => isChecked && !isAddNew && !isEditMode && !isDefaultAddress(shippingAddress),
    [isAddNew, isEditMode, isChecked, shippingAddress])
  const isShowEditButton = useMemo(() => isChecked && !isAddNew && !isEditMode, [isAddNew, isEditMode, isChecked])

  useEffect(() => {
    if (selectId !== id) {
      setIsEditmode(false)
    }
  }, [selectId, id])

  return (
    <div className="shipping-address-item">
      <Radio
        value={id}
        className={classNames('shipping-address-item-radio', {
          'shipping-address-item-radio-checked': isChecked,
          'shipping-address-default-item': isDefaultAddress(shippingAddress),
          'shipping-address-add-new': isAddNew,
        })}
      >
        {
                    isAddNew ? (
                      <div className="shipping-address-item-radio-container">
                        <Locale id="passport.shipping.address.add.new.label" />
                      </div>
                    ) : (
                      <div className="shipping-address-item-radio-container">
                        <div className="static-address">
                          <AddressStatic address={shippingAddress.address} nowrap />
                        </div>
                        <div className="operating-area">
                          { isDefaultAddress(shippingAddress) && <span className="default-tag"><Locale id="passport.shipping.address.default.text" /></span> }
                          {
                                isShowSetAsDefault && (
                                <LinkButton onClick={onSetDefault}>
                                  <Locale id="passport.shipping.address.set.default.label" />
                                </LinkButton>
                                )
                            }
                          {
                                isShowEditButton && <IconButton icon="ic-edit" alt="edit" onClick={() => setIsEditmode(true)} />
                            }
                          {
                                isChecked && <IconButton icon="ic-trash-can" alt="delete" onClick={onDelete} />
                            }
                        </div>
                      </div>
                    )
                }
      </Radio>
      {
                isShowEditor
                && (
                <div className="shipping-address-item-editor">
                  <ShippingAddressEditor
                    initialValues={shippingAddress}
                    name="address"
                  />
                </div>
                )
            }
    </div>
  )
}

ShippingListItem.propTypes = {
  id: string.isRequired,
  selectId: string.isRequired,
  shippingAddress: object.isRequired,
  onDelete: func.isRequired,
  onSetDefault: func.isRequired,
}

export default ShippingListItem
